import ContactHero from "../components/contact/ContactHero";
import ContactPageBody from "../components/contact/ContactPageBody";
import useSEO from "../hooks/useSEO";
import seoConfig from "../config/seoConfig";
import { generateWebPageSchema } from "../utils/schemaGenerators";
import { useTranslation } from "react-i18next";

export default function ContactPage() {
  const { t } = useTranslation();
  const seo = useSEO({
    schema: generateWebPageSchema({
      name: t("staticPages.contact.title", "Contact"),
      description: t("staticPages.contact.subtitle", "Get in touch"),
      url: `${seoConfig.siteUrl}/contact`,
    }),
  });

  return (
    <>
      {seo}
      <ContactHero />
      <ContactPageBody />
    </>
  );
}
